const footerSl = {
	company: 'ග්‍රාමීන් බසාර්',
	description: 'ශ්‍රී ලංකාවේ විශාලතම ජාල වෙළඳපොළකට සාදරයෙන් පිළිගනිමු.',
	links: {
		company: 'කාම්පැනිය',
		business: 'ව්‍යාපාර',
		support: 'සහාය',
		about: 'අප ගැන',
		career: 'රැකියා',
		contact: 'සම්බන්ධ වන්න',
		help: 'උදව්',
		becomeSeller: 'විකුණන්නෙකුවන්න',
		businessAccount: 'ව්‍යාපාර ගිණුම',
		marketplacePolicy: 'වෙළඳපොළ ප්‍රතිපත්තිය',
		deliveryPolicy: 'බෙදාහැරීමේ ප්‍රතිපත්තිය',
		returnPolicy: 'ආපසු ලබාදීමේ ප්‍රතිපත්තිය',
		privacyPolicy: 'රහස්‍යතා ප්‍රතිපත්තිය',
	},
	contact: {
		heading: 'සම්බන්ධතා',
		address: 'House #123, Road #45, Banani, Dhaka-1213',
	},
	copyright: (year) => `© ${year} ග්‍රාමීන් බසාර්. සියලු හිමිකම් ඇවිරිණි.`,
};

export default footerSl;


